const initViewSwitcher = () => {
  const toggles = document.querySelectorAll('[data-view-switcher-toggle]');
  const display = document.querySelector('[data-view-switcher-display]');
  const toggleClass = 'search-view-switcher__button--active';
  const localStorageKeyDt = 'bb-view-dt';
  const localStorageKeyMb = 'bb-view-mb';
  const breakpoint = 1024;

  if (!toggles.length || !display) return;

  // Helper to get the current localStorage key based on viewport
  const getCurrentKey = () => {
    return window.innerWidth >= breakpoint ? localStorageKeyDt : localStorageKeyMb;
  };

  // Helper to update toggle button states
  const setActiveToggle = view => {
    toggles.forEach(toggle => {
      toggle.classList.toggle(toggleClass, toggle.dataset.viewSwitcherToggle === view);
    });
  };

  // Helper to update display class
  const setDisplayClass = view => {
    // Remove any class that starts with 'grid-list--' except 'grid-list--collection'
    display.classList.forEach(cls => {
      if (cls.startsWith('grid-list--') && cls !== 'grid-list--collection') {
        display.classList.remove(cls);
      }
    });
    display.classList.add(`grid-list--${view}`);
  };

  // Helper to initialize view from localStorage
  const initializeView = () => {
    const key = getCurrentKey();
    const savedView = localStorage.getItem(key);
    if (savedView) {
      setActiveToggle(savedView);
      setDisplayClass(savedView);
    } else {
      // Optionally, set a default view here if needed
      // setActiveToggle('default');
      // setDisplayClass('default');
    }
  };

  // Initialize on load
  initializeView();

  toggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      const target = e.currentTarget;
      const view = target.dataset.viewSwitcherToggle;
      if (target.classList.contains(toggleClass)) return;
      setActiveToggle(view);
      setDisplayClass(view);
      localStorage.setItem(getCurrentKey(), view);
    });
  });

  // Listen for window resize to switch view if crossing breakpoint
  let lastIsDesktop = window.innerWidth >= breakpoint;
  window.addEventListener('resize', () => {
    const isDesktop = window.innerWidth >= breakpoint;
    if (isDesktop !== lastIsDesktop) {
      lastIsDesktop = isDesktop;
      initializeView();
    }
  });
};

export default initViewSwitcher;
